import React from 'react'
import ReactDOMClient from 'react-dom'
import App from './App'
import './css/main.css'
import './styles/fonts.css';

const app = ReactDOMClient.createRoot(document.getElementById('app'))

app.render(<App />)